import { ReactNode } from 'react';
import { Button, Flex, Typography, type ButtonProps } from 'antd';
import styled from '@emotion/styled';

export const MobileActionBar = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  flex-wrap: nowrap;
`;

export const MobileActionButton = styled(Button)`
  flex: 1 1 0;
  min-width: 0;
  height: 68px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px;
  font-size: 12px;
  line-height: 1.2;
  border-radius: 8px;
`;

const ActionContentWrapper = styled(Flex)`
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  padding: 4px 0;
`;

const ActionLabel = styled(Typography.Text)`
  margin: 0;
  font-size: 12px;
  line-height: 1.2;
`;

type MobileActionContentProps = {
  icon: ReactNode;
  label: string;
  className?: string;
};

export const MobileActionContent = ({ icon, label, className }: MobileActionContentProps) => (
  <ActionContentWrapper className={className}>
    {icon}
    <ActionLabel>{label}</ActionLabel>
  </ActionContentWrapper>
);

export type MobileActionButtonProps = ButtonProps;
